import { create } from 'zustand';

const initialState = {
  isOpen: false,
  type: '', // 'success' | 'warning'
  title: '',
  description: '',
  violations: [],
  onClick: null,
  primaryButtonLabel: null,
  lateClockInMinutes: 0,
};

export const useStatusState = create((set) => ({
  ...initialState,
  onOpenStatusState: (newState) => set((state) => ({ ...state, ...newState, isOpen: true })),
  onResetStatusState: () => set(() => initialState),
}));
